import axios from 'axios';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'justifiedGallery';
import {createApp, defineAsyncComponent} from 'vue';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Cookies from 'js-cookie';
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import {RayPlugin} from 'vue-ray';
import {useCartStore} from "./stores/CartStore";
import 'focus-visible'

UIkit.use(Icons);

window.$ = window.jQuery = require('jquery');
window.axios = axios;
window.UIkit = UIkit;
window.Cookies = Cookies;

window.COOKIE_NAME_LEAD = 'CWLEAD';

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
// pinia.use(storeReset)

const app = createApp()

// Chooser components
app.component('the-chooser', defineAsyncComponent(() => import('./components/chooser/TheChooser.vue')));
app.component('chooser-load-big-sets-button', defineAsyncComponent(() => import('./components/chooser/ChooserLoadBigSetsButton.vue')));
app.component('chooser-load-small-sets-button', defineAsyncComponent(() => import('./components/chooser/ChooserLoadSmallSetsButton.vue')));
app.component('chooser-load-staff-picks-button', defineAsyncComponent(() => import('./components/chooser/ChooserLoadStaffPicksButton.vue')));
app.component('chooser-preload-product-line-sausage', defineAsyncComponent(() => import('./components/chooser/ChooserPreloadProductLineSausage.vue')));
app.component('chooser-preload-product-line-playhouses-sausage', defineAsyncComponent(() => import('./components/chooser/ChooserPreloadProductLinePlayhousesSausage.vue')));
app.component('chooser-preload-product-line', defineAsyncComponent(() => import('./components/chooser/ChooserPreloadProductLine.vue')));
app.component('chooser-preload-product-line-block-style', defineAsyncComponent(() => import('./components/chooser/ChooserPreloadProductLineBlockStyle.vue')));
app.component('TheChooserResultsLoad', defineAsyncComponent(() => import('./components/chooser/TheChooserResultsLoad.vue')));

// Cart components
app.component('cart', defineAsyncComponent(() => import('./components/cart/Cart.vue')));
app.component('cart-count', defineAsyncComponent(() => import('./components/cart/CartCount.vue')));
app.component('add-to-cart', defineAsyncComponent(() => import('./components/cart/AddToCart.vue')));
app.component('add-to-cart-button-sausage', defineAsyncComponent(() => import('./components/cart/AddToCartButtonSausage.vue')));

// Wishlist components
app.component('wishlist', defineAsyncComponent(() => import('./components/wishlist/Wishlist.vue')));
app.component('wishlist-item', defineAsyncComponent(() => import('./components/wishlist/WishlistItem.vue')));
app.component('wishlist-count', defineAsyncComponent(() => import('./components/wishlist/WishlistCount.vue')));
app.component('wishlist-link-main-nav', defineAsyncComponent(() => import('./components/wishlist/WishlistLinkMainNav.vue')));
app.component('save-to-wishlist-mini-heart-style', defineAsyncComponent(() => import('./components/wishlist/SaveToWishlistMiniHeartStyle.vue')));
app.component('save-to-wishlist-portrait-style', defineAsyncComponent(() => import('./components/wishlist/SaveToWishlistPortraitStyle.vue')));
app.component('remove-from-wishlist', defineAsyncComponent(() => import('./components/wishlist/RemoveFromWishlist.vue')));

// Design components
app.component('design-tool-goto-button', defineAsyncComponent(() => import('./components/design-tool/DesignToolGotoButton.vue')));
app.component('design-tool-goto-button-sausage', defineAsyncComponent(() => import('./components/design-tool/DesignToolGotoButtonSausage.vue')));
app.component('design-tool-goto-link', defineAsyncComponent(() => import('./components/design-tool/DesignToolGotoLink.vue')));

// Modals components
app.component('three-dee-modal', defineAsyncComponent(() => import('./components/ui/ThreeDeeModal.vue')));
app.component('act-fast-modal', defineAsyncComponent(() => import('./components/act-fast/ActFastModal.vue')));
app.component('lead-modal', defineAsyncComponent(() => import('./components/lead/LeadModal.vue')));
app.component('catalog-modal', defineAsyncComponent(() => import('./components/catalog/CatalogModal.vue')));
app.component('birds-eye-modal', defineAsyncComponent(() => import('./components/ui/BirdsEyeModal.vue')));
app.component('the-clippy-modal', defineAsyncComponent(() => import('./components/clippy/TheClippyModal.vue')));
app.component('show-lead-modal-main-nav', defineAsyncComponent(() => import('./components/lead/ShowLeadModalMainNav.vue')));
app.component('show-lead-modal-button', defineAsyncComponent(() => import('./components/lead/ShowLeadModalButton.vue')));
app.component('show-lead-modal-product-grid', defineAsyncComponent(() => import('./components/lead/ShowLeadModalProductGrid.vue')));
app.component('design-tool-width-modal', defineAsyncComponent(() => import('./components/design-tool/DesignToolWidthModal.vue')));

// Clippy components
app.component('the-clippy-launchpad', defineAsyncComponent(() => import('./components/clippy/TheClippyLaunchpad.vue')));
app.component('product-line-start-clippy', defineAsyncComponent(() => import('./components/clippy/ProductLineStartClippy.vue')));

// Banner components
app.component('banner', defineAsyncComponent(() => import('./components/banners/Banner.vue')));
app.component('cookie-notice', defineAsyncComponent(() => import('./components/banners/CookieNotice.vue')));

// Misc components
app.component('product-dimensions', defineAsyncComponent(() => import('./components/utilities/ProductDimensions.vue')));
app.component('faq-item', defineAsyncComponent(() => import('./components/faq/FaqItem.vue')));
app.component('the-product-search', defineAsyncComponent(() => import('./components/site/TheProductSearch.vue')));
app.component('view-birds-eye', defineAsyncComponent(() => import('./components/ui/ViewBirdsEye.vue')));
app.component('view-three-dee-portrait-style', defineAsyncComponent(() => import('./components/ui/ViewThreeDeePortraitStyle.vue')));
app.component('view-three-dee-portrait-style-indoor', defineAsyncComponent(() => import('./components/ui/ViewThreeDeePortraitStyleIndoor.vue')));

app.use(pinia)

app.use(RayPlugin, {
    host: '10.0.9.126'
});

app.mount('#vue-app');

// location of this line is intentional.  MUST be placed after app.mount()
window.CartStore = useCartStore();

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
